import { useLogout } from '../hooks/useLogout'
import { useAuthContext } from '../hooks/useAuthContext'

import '../styling/header.css'
import '../styling/burger.css'
import { strings } from '../strings'
import { Link } from 'react-router-dom'

import { slide as Menu } from 'react-burger-menu'
import homeLogo from "../styling/images/logga_vit.png"

const Header = () => {

  const { logout } = useLogout()
  const { user } = useAuthContext()

  let w = window.innerWidth
  let h = window.innerHeight

  const handleClick = () => {
    logout()
  }

  return (
    <header className='header'>
      <Link to="/">
        <img className='home-logo' src={homeLogo} alt='home-logo' />
      </Link>

      {user && (
        <nav className='nav-btns'>
          <button className='logout-btn' onClick={handleClick}>{strings.home.logout}</button>
          {(user && !user.isAdmin) &&
          <Menu right width={h < w ? "20vw" : "60vw"} styles={{ bmItemList: { height: "50%" }, bmBurgerButton: { right: h < w ? '12vw' : '30vw' } }} >
            <Link className="menu-item nav-link" to="/">{strings.burger.start}</Link>
            <Link className="menu-item nav-link" to="/history">{strings.burger.history}</Link>
            <Link className="menu-item nav-link" to="/payment">{strings.burger.pay}</Link>
          </Menu>}
        </nav>
      )
      }
    </header >
  )
}

export default Header
